import { render, staticRenderFns } from "./empty-component.vue?vue&type=template&id=0de1c54d&scoped=true&"
import script from "./empty-component.vue?vue&type=script&lang=js&"
export * from "./empty-component.vue?vue&type=script&lang=js&"
import style0 from "./empty-component.vue?vue&type=style&index=0&id=0de1c54d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de1c54d",
  null
  
)

export default component.exports